import Cookies from 'js-cookie';
import { find, uniqBy, findIndex } from 'lodash';
import auth from '@/lib/auth';
import * as model from '../comm/model/';
import * as types from './mutation-types';
import { updateLoginInfo } from '../comm/utils';

function resetSocketState(state, type) {
  if (type === 6) {
    state.audio = {
      serverId: null,
      speech: null
    };
  }
}

export default {
  [types.AJAX_LOADING](state, { loadingStatus }) {
    state.isLoading = loadingStatus;
  },

  [types.AJAX_HOT_LABEL_LIST](state, hotLabelList) {
    state.hotLabelList = hotLabelList;
  },

  [types.TREE_COIN_INFO](state, treeCoinInfo) {
    state.treeCoinInfo.balance = treeCoinInfo.balance;
    state.treeCoinInfo.accountList = treeCoinInfo.data || [];
  },

  // update by qiuhong 20180309
  [types.SERIAL_LIST](state, { info, curpage, curType }) {
    const { type, list } = state.serialList;
    let newList = [];
    if (type !== curType) {
      state.serialList = Object.assign({}, {
        type: curType,
        list: info.list,
        curpage,
        hasNextPage: info.hasNextPage || false
      });
    } else {
      newList = newList.concat(list);
      newList = newList.concat(info.list);
      state.serialList = Object.assign({}, state.serialList, {
        list: newList,
        curpage,
        hasNextPage: info.hasNextPage || false
      });
    }
  },

  [types.TREE_COIN_INFO_MORE](state, treeCoinInfo) {
    if (treeCoinInfo.pageNo === 1) {
      state.treeCoinInfo.list = treeCoinInfo.list;
    } else {
      state.treeCoinInfo.list = state.treeCoinInfo.list.concat(treeCoinInfo.list);
    }
    state.treeCoinInfo.hasNextPage = treeCoinInfo.hasNextPage;
  },

  [types.AJAX_GET_COURSE_RECOMMEND](state, courseRecommends) {
    state.courseRecommends = courseRecommends.rs;
  },

  // 免费更多推荐
  [types.AJAX_GET_LAMA_RECOMMEND](state, lamaRecommends) {
    state.lamaRecommends = lamaRecommends.rs;
  },

  [types.COURSE_CLOSED](state, { status }) {
    state.courseCloseState = status;
  },

  // 存储 socket 到 全局状态
  [types.SOCKET_CONNECT](state, { socket }) {
    state.socket = socket;
  },

  // socket 链接状态
  [types.SOCKET_CONNECT_STATUS](state, { status }) {
    if (!status) {
      // 轮询插入消息
      window.clearInterval(window.messageInterval);
    }
    state.connectStatus = status;
  },

  // socket 发送信息
  [types.SOCKET_SEND_MESSAGE](state, { message }) {
    state.sendMessages[message.clientSeqId] = message;
    if (message.type === 7 || message.type === 8) {
      state.replayMessageIds.push(message.refMsgId);
    }
    resetSocketState(state, message.type);
  },

  [types.SOCKET_RECEIVE_MESSAGE_UP](state, { courseUpCount }) {
    state.courseUpCount = courseUpCount;
  },

  // socket 接收喜欢按钮的信息
  [types.SOCKET_RECEIVE_MESSAGE_LIKE_COUNT](state, { msgId, count, likeType }) {
    if (likeType === 'message') {
      // 喜欢的是 信息
      const message = find(state.messages, messageItem => (messageItem.id === msgId));
      message.interestCount = count;
      message.like = true;
    } else if (likeType === 'question') {
      // 喜欢的是 问题
      const userIssues = find(state.userIssues.list, issuesItem => (issuesItem.id === msgId));
      console.log(count);
      userIssues.sender.like = true;
      userIssues.interestCount += 1;
    }
  },

  [types.SOCKET_RECEIVE_MESSAGE](state, { messages, clientSeqId }) {
    const newMessages = [];
    if (messages) {
      let latestMessage = state.latestMessage;
      /* eslint-disable */
      for (let message of messages) {
        const messageModel = model.message(message);

        // 在消息池里找是否有一样的数据
        const result = find(state.messages, messageItem => (messageItem.id === messageModel.id));
        // 快速插入逻辑
        if (!result || messageModel.quickInsert) {
          // 设置最后一条消息
          if (!latestMessage || messageModel.createTime > latestMessage.createTime) {
            latestMessage = messageModel;
          }

          // 判断队列中的问题是否已经被回答过了
          if (messageModel.type === 3) {
            const refFlag = find(state.replayMessageIds, refId => (refId === messageModel.id));

            if (refFlag) {
              messageModel.refMessage = true;
            }
          }
          if ((messageModel.type === 6 || messageModel.type === 7) && !messageModel.deleted) {
            messageModel.mediaId = messages[0].mediaId;
            messageModel.playStatus = false; // 是否播放

            if (!messageModel.quickInsert) {
              let isQuickInsert = false;
              console.log(`message ${JSON.stringify(message)}`);
              console.log(`audioList ${state.audioList.length}`);
              for (let audio of state.audioList) {
                if (audio.quickInsert && audio.clientSeqId === clientSeqId) {
                  isQuickInsert = true;
                  Object.assign(audio, messageModel);
                  Object.assign(audio.messageModel, messageModel);
                  // audio.id = messageModel.id;
                  // audio.src = messageModel.content;
                  // audio.speech = messageModel.speech;
                  // audio.playStatus = messageModel.playStatus;
                  audio.quickInsert = false;
                  break;
                }
              }
              if (isQuickInsert) {
                continue;
              }
            } else {
              messageModel.contentCopy = messageModel.content;
            }

            const audio = {
              id: messageModel.id,
              src: messageModel.content,
              speech: messageModel.speech,
              playStatus: messageModel.playStatus,
            };

            if (messageModel.quickInsert) {
              Object.assign(audio, {
                clientSeqId: messageModel.clientSeqId,
                quickInsert: messageModel.quickInsert,
                messageModel,
              });
            }
            state.audioList.push(audio);
          }
          newMessages.push(messageModel);
          // messageModel.uploadStatus = 2;
          console.log('pushmessageModel', messageModel);
        }
      }
      /* esint-enable */
      if (newMessages.length) {
        console.log(`newMessages ===> ${JSON.stringify(newMessages)}`);
        const concatMessages = state.messages.concat(newMessages);
        if (concatMessages.length > 50 && !state.isLookHistoryMessage) {
          concatMessages.splice(0, concatMessages.length - 50);
        }
        state.messages = concatMessages;
        state.latestMessage = latestMessage;
      }
    }
  },

  [types.SOCKET_RECEIVE_MESSAGE_DELETE](state, { msgId }) {
    state.messages.forEach((message, i, array) => {
      if (message.id === msgId) {
        array.splice(i, 1);
      }
    });
    state.audioList.forEach((item, i, array) => {
      if (item.id === msgId) {
        array.splice(i, 1);
      }
    });
  },

  [types.AJAX_ERROR](state, err) {
    if (err.message.indexOf('已过期') > 0) {
      auth.clear();
    }
    state.error = err;
  },

  [types.RESET_MESSAGES](state) {
    state.messages = [];
    state.messageStore = [];
    state.audioList = [];
  },

  [types.RESET_MESSAGE_STORE](state) {
    state.messageStore = [];
  },

  // 获取聊天信息
  [types.AJAX_GET_MESSAGES](state, { messages }) {
    const newMessages = [];
    let firstMessage = null;
    let latestMessage = null;

    /* eslint-disable */
    // 如果有消息
    if (messages.length) {
      for (let message of messages) {
        const messageModel = model.message(message);
        // 设置最后一条消息
        if (!latestMessage || messageModel.createTime > latestMessage.createTime) {
          latestMessage = messageModel;
        }

        // 设置第一条信息
        if (!firstMessage || messageModel.createTime < firstMessage.createTime) {
          firstMessage = messageModel;
        }

        // 过滤 音频消息
        if (messageModel.type === 6 || messageModel.type === 7) {
          messageModel.playStatus = false; // 是否播放
          state.audioList.push({
            id: messageModel.id,
            src: messageModel.content,
            speech: messageModel.speech,
            playStatus: messageModel.playStatus,
          });
        }

        // 消息格式化成功
        newMessages.push(messageModel);
      }

      state.messages = uniqBy(newMessages.concat(state.messages), 'id');

      if (latestMessage) {
        state.latestMessage = latestMessage;
      }

      state.firstMessage = firstMessage;
    }

    // 设置第一次请求成功
    if (state.firstAjaxStatus === 0) {
      state.firstAjaxStatus = 1;
    }
    /* esint-enable */
  },

  [types.AJAX_GET_COURSELIST](state, { courseList, pageNo }) {
    let courseTemp;
    const courseListTemp = [];
    courseList.list.forEach((course) => {
      courseTemp = model.course(course);
      courseListTemp.push(courseTemp);
    });
    if (pageNo === 1 || pageNo === '1' || pageNo === '') {
      state.courseList = {
        hasNextPage: courseList.hasNextPage,
        data: courseListTemp,
        pageNo,
      };
    } else {            // 分页加载
      state.courseList.data.push(...courseListTemp);
      state.courseList = {
        hasNextPage: courseList.hasNextPage,
        data: state.courseList.data,
        pageNo,
      };
    }
  },

  [types.AJAX_GET_COURSEINFO](state, { courseInfo, filter = false }) {
    state.courseInfo = filter ? model.course(courseInfo) : courseInfo;
    state.courseUpCount = state.courseInfo.likeNum;
  },
  // 获取新版课程详情
  [types.AJAX_GET_NEWCOURSEINFO](state, { newCourseInfo, filter = false }) {
    // todo newCourseInfo 毫无意义，后期应该把引用state内的newCourseInfo 清除
    state.newCourseInfo = newCourseInfo;
    state.courseInfo = newCourseInfo;
  },

  [types.AJAX_GET_SERIALCOURSEINFO](state, { courseInfo, filter = true }) {
    state.courseInfo = filter ? model.course(courseInfo) : courseInfo;
    state.courseUpCount = state.courseInfo.likeNum;
  },

  // 获取素材图片列表
  [types.AJAX_GET_MATERIAL_PICTURELIST](state, { pictureList, naxtPage, hasPictures }) {
    let pictureTemp;
    const pictureListTemp = [];
    // 设置分页状态
    state.hasPictures = hasPictures;
    // 格式化列表
    pictureList.forEach((picture) => {
      pictureTemp = model.picture(picture);
      pictureListTemp.push(pictureTemp);
    });
    console.log('AJAX_GET_MATERIAL_PICTURELIST', naxtPage);
    if (naxtPage) {
      if (pictureListTemp.length > 0) {
        state.materialPictureList = state.materialPictureList.concat(pictureListTemp);
      }
    } else {
      state.materialPictureList = pictureListTemp;
    }
    console.log('materialPictureList', state.materialPictureList);
    // if (pictureListTemp.length > 0) {
    //   state.pictureList = state.pictureList.concat(pictureListTemp);
    // }
  },
  // 获取素材PPT图片列表
  [types.AJAX_GET_MATERIAL_PPTLIST](state, { PPTList, naxtPage, hasPPTs }) {
    let pictureTemp;
    const pictureListTemp = [];
    // 设置分页状态
    state.hasPPTs = hasPPTs;
    // 格式化列表
    PPTList.forEach((picture) => {
      pictureTemp = model.picture(picture);
      pictureListTemp.push(pictureTemp);
    });
    if (naxtPage) {
      if (pictureListTemp.length > 0) {
        state.materialPPTList = state.materialPPTList.concat(pictureListTemp);
      }
    } else {
      state.materialPPTList = pictureListTemp;
    }
  },

  // 素材库音频列表
  [types.AJAX_GET_MATERIAL_AUDIOLIST](state, { audioList, naxtPage, hasNextPage }) {
    let audioTemp;
    const audioListTemp = [];
    audioList.forEach((audio) => {
      audioTemp = model.audio(audio);
      audioListTemp.push(audioTemp);
    });
    console.log('AJAX_GET_MATERIAL_AUDIOLIST', naxtPage, hasNextPage);
    if (naxtPage) {
      if (audioListTemp.length > 0) {
        state.materialaAudioList = state.materialaAudioList.concat(audioListTemp);
        if (state.materialaAudioList.length > 0 && !hasNextPage) {
          state.materialaAudioList[state.materialaAudioList.length - 1].last = true;
        }
      }
    } else {
      state.materialaAudioList = audioListTemp;
      if (state.materialaAudioList.length > 0 && !hasNextPage) {
        state.materialaAudioList[state.materialaAudioList.length - 1].last = true;
      }
    }
  },

  // 素材库视频列表
  [types.AJAX_GET_MATERIAL_VIDEOLIST](state, { videoList, naxtPage, hasNextPage }) {
    let videoTemp;
    const videoListTemp = [];
    videoList.forEach((video) => {
      videoTemp = model.video(video);
      videoListTemp.push(videoTemp);
    });

    if (naxtPage) {
      if (videoListTemp.length > 0) {
        state.materialaVideoList = state.materialaVideoList.concat(videoListTemp);
        if (state.materialaVideoList.length > 0 && !hasNextPage) {
          state.materialaVideoList[state.materialaVideoList.length - 1].last = true;
        }
      }
    } else {
      state.materialaVideoList = videoListTemp;
      if (state.materialaVideoList.length > 0 && !hasNextPage) {
        state.materialaVideoList[state.materialaVideoList.length - 1].last = true;
      }
    }
  },

  [types.AJAX_WX_SIGN_STATUS](state, { status = 0 }) {
    state.wxSignStatus = status;
  },

  [types.AJAX_WX_STARTRECORD](state) {
    console.log('AJAX_WX_STARTRECORD');
    state.startRecordTime = new Date();
    state.audio.isUpload = false;
  },

  [types.AJAX_WX_STOPRECORD](state, payload) {
    console.log('AJAX_WX_STOPRECORD');
    state.startRecordTime = null;
    state.audio = payload;
  },

  [types.AJAX_WX_UPDATERECORD](state, payload) {
    console.log('AJAX_WX_UPDATERECORD');
    payload.audioState = 'update';
    state.audio = payload;
  },

  [types.AJAX_WX_RERECORD](state) {
    console.log('AJAX_WX_RERECORD');
    state.startRecordTime = null;
    state.audio = {
      serverId: null,
      speech: null,
      isUpload: false,
    };
  },

  [types.AJAX_WX_UPLOADRECORD](state) {
    state.audio.isUpload = true;
  },

  [types.AJAX_WX_ONVOICERECORDEND]() {
  },

  [types.AJAX_WX_UPLOADVOICE]() {
  },

  [types.AJAX_WX_GETNETWORKTYPE]() {
  },

  [types.AJAX_WX_CHOOSEIMAGE](state, { imageLocalIds }) {
    state.imageLocalIds = imageLocalIds;
  },

  [types.AJAX_WX_CHOOSESENDIMAGE](state, { imageServerIds }) {
    state.sendImageLocalIds = imageServerIds;
  },

  [types.DELETEIMAGEONLOCAL](state, { imageIds }) {
    imageIds.forEach(value =>
      state.materialPictureList.forEach((_v, _i) => {
        if (value === _v.id) {
          state.materialPictureList.splice(_i, 1);
        }
      }));
  },
  // 删除本地专家素材库图片/声音列表
  [types.CLEAR_MATERIALLIST_LOCAL](state) {
    state.materialPictureList = [];
    state.materialaAudioList = [];
    state.materialaVideoList = [];
  },

  [types.AJAX_GET_EXPERTAUTH](state, { info }) {
    state.expertInfo = model.expertInfo(info);
  },

  // 当前消息
  [types.COMPONENTS_CURRENTMESSAGE](state, { replyMessage }) {
    state.replyMessage = replyMessage;
  },

  // 素材库
  [types.COMPONENTS_POPUPVISIBLE](state, payload) {
    state.livePopupVisible = payload.livePopupVisible;
  },

  // 编辑栏
  [types.COMPONENTS_LIVEBARACTIVE](state, payload) {
    state.isActive = payload.isActive;
  },

  [types.AJAX_GET_ISSUES](state, { issues, lastId }) {
    if (lastId) {
      state.issues.list.push(...issues.list);
      state.issues = {
        hasNextPage: issues.hasNextPage,
        list: state.issues.list,
      };
    } else {
      state.issues = issues;
    }
  },

  // 用户授权
  [types.AJAX_GET_USERINFO](state, { userInfo }) {
    updateLoginInfo({ token: userInfo.token, userInfo });
    state.userInfo = userInfo;
  },

  // 用户下单
  [types.AJAX_BUY_INFO](state, { buyInfo }) {
    state.buyInfo = buyInfo;
    const courseInfo = state.courseInfo;
    if (buyInfo.amount === 0) {
      courseInfo.join = true;
    }
    state.courseInfo = courseInfo;
  },

  // 用户购买
  [types.AJAX_PAY_INFO](state, { payInfo }) {
    state.payInfo = payInfo;
  },

  // 获取订单信息
  [types.AJAX_ORDER_INFO](state, { preOrderInfo }) {
    state.preOrderInfo = preOrderInfo;
  },

  // 更新单条消息回复状态
  [types.UPDATE_MESSAGE_REF_STATUS](state, { refMsgId }) {
    state.messages.forEach((message) => {
      if (Number(message.id) === Number(refMsgId)) {
        message.refMessage = true;
      }
    });
  },

  // 大健康用户签名
  [types.AJAX_GET_SIGNDATA](state, { signData }) {
    state.signData = model.sign(signData);
  },

  // 更新查看历史消息状态
  [types.LOOK_HISTORY_MESSAGE](state, { status = 0 }) {
    state.isLookHistoryMessage = status;
  },
  // 课程评论
  [types.AJAX_POST_ADDCOMMENT](state, { commentId }) {
    const courseInfo = state.courseInfo;
    const newCourseInfo = state.newCourseInfo;
    console.log('mutation-courseInfo', commentId, courseInfo.id);
    if (commentId === courseInfo.id) {
      courseInfo.canComment = false;
    }
    state.courseInfo = courseInfo;
    if (commentId === newCourseInfo.id) {
      newCourseInfo.canComment = false;
    }
    state.newCourseInfo = newCourseInfo;
  },
  // 获取首页分类
  [types.AJAX_GET_CATAGORY](state, { list }) {
    state.catagoryList = list;
  },
  // 获取首页列表
  [types.AJAX_GET_INDEXLIST](state, { indexData, newPage }) {
    console.log('newPage', newPage);
    if (newPage) {
      const indexDataTemp = [];
      indexData.courseList.forEach((courseClassify) => {
        let courseTemp = {};
        const courseListTemp = [];
        courseClassify.list.forEach((course) => {
          courseTemp = model.course(course);
          courseListTemp.push(courseTemp);
        });
        if (courseClassify.startStatus === 1) {
          if (!indexDataTemp[0]) {
            indexDataTemp[0] = courseClassify;
          }
          indexDataTemp[0].list = courseListTemp;
        } else if (courseClassify.startStatus === 0) {
          if (!indexDataTemp[1]) {
            indexDataTemp[1] = courseClassify;
          }
          indexDataTemp[1].list = courseListTemp;
        } else if (courseClassify.startStatus === 2) {
          if (!indexDataTemp[2]) {
            indexDataTemp[2] = courseClassify;
          }
          indexDataTemp[2].list = courseListTemp;
        }
        // indexData.courseList[i].list = courseListTemp;
      });
      state.advertList = indexData.advertList;
      state.indexCourseList = indexDataTemp;
      state.indexCourseObj = {
        startStatus: indexData.startStatus,
        nextPageNum: indexData.nextPageNum,
      };
    } else {
      const tmpArray = state.indexCourseList;
      indexData.courseList.forEach((newList) => {
        if (newList.startStatus === 1) {
          if (tmpArray[0]) {
            tmpArray[0].list = tmpArray[0].list.concat(newList.list);
          } else {
            tmpArray[0] = newList;
          }
        }
        if (newList.startStatus === 0) {
          if (tmpArray[1]) {
            tmpArray[1].list = tmpArray[1].list.concat(newList.list);
          } else {
            tmpArray[1] = newList;
          }
        }
        if (newList.startStatus === 2) {
          if (tmpArray[2]) {
            tmpArray[2].list = tmpArray[2].list.concat(newList.list);
          } else {
            tmpArray[2] = newList;
          }
        }
      });
      tmpArray.forEach((courseClassify, i) => {
        let courseTemp = {};
        const courseListTemp = [];
        courseClassify.list.forEach((course) => {
          courseTemp = model.course(course);
          courseListTemp.push(courseTemp);
        });
        tmpArray[i].list = courseListTemp;
      });
      state.indexCourseList = tmpArray;
      state.indexCourseObj = {
        startStatus: indexData.startStatus,
        nextPageNum: indexData.nextPageNum,
      };
    }
  },

  // 音频开始加载
  [types.AUDIO_LOADSTART](state, { msgId }) {
    // state.messages.forEach((message) => {
    //   console.log('AUDIO_LOADSTART');
    //   if (Number(message.id) === Number(msgId)) {
    //     console.log('AUDIO_LOADSTART');
    //     message.loadstartStatus = true;
    //     message.playingStatus = false;
    //   }
    // });
    const message = find(state.messages, messageItem => (messageItem.id === msgId));
    message.loadstartStatus = true;
    message.playingStatus = false;
  },

  // 音频开始播放
  [types.AUDIO_PLAYING](state, { msgId }) {
    const message = find(state.messages, messageItem => (messageItem.id === msgId));
    message.playingStatus = true;
    message.loadstartStatus = false;
    if (state.lastPlayAudio) {
      // state.lastPlayAudio.playingStatus = false;
      state.lastPlayAudio.playingStatus = true;
    }
    state.lastPlayAudio = message;
  },

  // 音频停止播放
  [types.AUDIO_STOP](state, { msgId }) {
    const message = find(state.messages, messageItem => (messageItem.id === msgId));
    if (message) {
      message.loadstartStatus = false;
      message.playingStatus = false;
      if (state.lastPlayAudio) {
        state.lastPlayAudio.playingStatus = false;
      }
    }
  },

  // 蚂蚁支付
  [types.MY_PAY](state, { payInfo, status = 0 }) {
    state.payStatus = {
      ordernum: payInfo.ordernum,
      courseId: payInfo.courseId,
      status,
      type: 'MY_PAY',
    };
  },

  // 微信支付
  [types.WX_PAY](state, { payInfo, status = 0 }) {
    state.payStatus = {
      ordernum: payInfo.ordernum,
      courseId: payInfo.courseId,
      status,
      type: 'WX_PAY',
    };
  },
  // 清除支付状态
  [types.CLEAR_PAY_STATUS](state) {
    state.payStatus = {
      courseId: null,  // 课程id
      ordernum: null,  // 订单号
      status: 0,     // 成功1，默认0
    };
  },

  // 用户端获取问题列表
  [types.AJAX_GET_USER_ISSUES](state, { issues, lastId }) {
    const issuesTemp = [];
    issues.list.forEach((item) => {
      issuesTemp.push(model.userIssues(item));
    });
    if (lastId) {
      state.userIssues.list.push(...issuesTemp);
      state.userIssues = {
        hasNextPage: issues.hasNextPage,
        list: state.userIssues.list,
      };
    } else {
      state.userIssues = {
        hasNextPage: issues.hasNextPage,
        list: issuesTemp,
      };
    }
  },
  // 获取我的开讲
  [types.AJAX_GET_USERCOURSE](state, { courseData, newPage, coursetype }) {
    if (!coursetype) {
      let userCourseList = courseData.list;
      if (!newPage) {
        userCourseList = state.userCourse.list.concat(courseData.list);
      }
      state.userCourse = {
        list: userCourseList,
        hasNextPage: courseData.hasNextPage,
      };
    } else if (coursetype === 1) {
      let userSerialCourseList = courseData.list;
      if (!newPage) {
        userSerialCourseList = state.userSerialCourse.list.concat(courseData.list);
      }
      state.userSerialCourse = {
        list: userSerialCourseList,
        hasNextPage: courseData.hasNextPage,
      };
    }
  },
  // 获取我的组合课
  [types.AJAX_GET_COMBINECOURSE](state, { courseData, newPage }) {
    let userCourseList = courseData.list;
    if (!newPage) {
      userCourseList = state.combineCourse.list.concat(courseData.list);
    }
    state.combineCourse = {
      list: userCourseList,
      hasNextPage: courseData.hasNextPage,
    };
  },
  // 获取发送验证码
  [types.AJAX_POST_USERSENDCODE](state, { sedCodeInfo }) {
    state.sedCodeInfo = sedCodeInfo.rescode;
  },
  // 获取绑定手机号信息
  [types.AJAX_POST_USERBINDING](state, { bindMobileInfo }) {
    state.bindMobileInfo = bindMobileInfo;
    // 成功后更新用户信息
    state.userInfo.isHaveMobile = 1;
    state.userInfo.token = bindMobileInfo.user[0].token;
    Cookies.set('userInfo', state.userInfo);
    updateLoginInfo({ token: state.userInfo.token, userInfo: state.userInfo });
  },

  // --------------------- 用户端分割线 -------------------
  // 课堂页 - 幻灯片
  [types.AJAX_GET_SLIDES](state, { slides }) {
    state.slides = {
      list: slides,
      hasSlides: slides.length > 0,
    };
  },
  // 用户端 - 我的音频 - 音频
  [types.AJAX_GET_MYTINYAUDIO](state, { myTinyAudio, curpage }) {
    let list = [];
    if (curpage === 1) {
      // 首页，清空list
      list = myTinyAudio.list;
    } else {
      list = state.myTinyAudio.myTinyAudioList.concat(myTinyAudio.list);
    }
    state.myTinyAudio = {
      myTinyAudioList: list,
      hasNextPage: myTinyAudio.hasNextPage,
    };
  },

  // 用户端 - 更新全局audio5 对象
  [types.AJAX_UPDATE_AUDIO5](state, { audio5, audioObj }) {
    audio5.src = audioObj.url;
    audio5.playId = audioObj.id;
    state.audio5 = audio5;
  },

  // 用户端 - 我的音频 - 专辑
  [types.AJAX_GET_MYTINYALBUM](state, { myTinyAlbum, curpage }) {
    let list = [];
    if (curpage === 1) {
      // 首页，清空list
      list = myTinyAlbum.list;
    } else {
      list = state.myTinyAlbum.myTinyAlbumList.concat(myTinyAlbum.list);
    }
    state.myTinyAlbum = {
      myTinyAlbumList: list,
      hasNextPage: myTinyAlbum.hasNextPage,
    };
  },

  // 用户端 - 我的视频 - 视频
  [types.AJAX_GET_MYTINYVIDEO](state, { myTinyVideo, curpage }) {
    let list = [];
    if (curpage === 1) {
      // 首页，清空list
      list = myTinyVideo.list;
    } else {
      list = state.myTinyVideo.myTinyVideoList.concat(myTinyVideo.list);
    }
    state.myTinyVideo = {
      myTinyVideoList: list,
      hasNextPage: myTinyVideo.hasNextPage,
    };
  },

  // 用户端 - 我的视频 - 专辑
  [types.AJAX_GET_MYTINYVIDEOALBUM](state, { myTinyVideoAlbum, curpage }) {
    let list = [];
    if (curpage === 1) {
      // 首页，清空list
      list = myTinyVideoAlbum.list;
    } else {
      list = state.myTinyVideoAlbum.myTinyVideoAlbumList.concat(myTinyVideoAlbum.list);
    }
    state.myTinyVideoAlbum = {
      myTinyVideoAlbumList: list,
      hasNextPage: myTinyVideoAlbum.hasNextPage,
    };
  },

  // 组合课程列表
  [types.AJAX_GET_GROUPALBUM](state, { groupAlbum, curpage }) {
    console.log(groupAlbum);
    let list = [];

    if (curpage === 1) {
      list = groupAlbum.list; // 第一页处理
    } else {
      list = state.groupAlbum.groupAlbumList.concat(groupAlbum.list);
    }

    state.groupAlbum = {
      groupAlbumList: list,
      hasNextPage: groupAlbum.hasNextPage,
    };

    console.log(state.groupAlbum);
  },

  // 收银台支付
  [types.CASHIER_PAY](state, { status = 0 }) {
    state.cashierPayStatus = status;
  },

  // 用户端 - 免费小微课
  [types.AJAX_GET_FREETINYAUDIO](state, { freeTinyCourseList, curpage }) {
    let list = [];
    if (curpage === 1) {
      // 首页，清空list
      list = freeTinyCourseList.list;
    } else {
      list = state.freeTinyCourse.list.concat(freeTinyCourseList.list);
    }
    state.freeTinyCourse = {
      list: list,
      hasNextPage: freeTinyCourseList.hasNextPage,
    };
  },

  // 首页 提示条
  [types.COURSE_REMIND](state, { courseRemind }) {
    state.indexInfo.courseRemind = courseRemind;
  },

  // 首页 提示条状态
  [types.REMIND_CLOSE](state, { closeStatus }) {
    state.indexInfo.closeStatus = closeStatus;
  },

  // 首页 页面数据
  [types.HOME_INFO](state, { pageInfo }) {
    state.indexInfo.pageInfo = pageInfo;
  },

  // 首页 为你推荐列表
  [types.RECOMMEND_LIST](state, { recommendList }) {
    const list = state.indexInfo.recommendList.concat(recommendList.list);
    state.indexInfo.recommendList = list;
    state.indexInfo.hasNextPage = recommendList.hasNextPage;
    state.indexInfo.nextPageNum = recommendList.curpage + 1;
  },

  // 首页 热门开讲
  [types.CHANGE_HOTCOURSE](state, { hotCourse }) {
    state.indexInfo.hotCourse = hotCourse;
  },
  // 首页 模块列表
  [types.INDEX_MODULE_LIST](state, { indexModuleList }) {
    state.indexInfo.indexModuleList = indexModuleList;
  },

  // 获取我的课程
  [types.AJAX_GET_MYCOURSE](state, { courseList }) {
    const myCourseList = state.myCourse.list.concat(courseList.dataList);
    state.myCourse = {
      list: myCourseList,
      hasNextPage: courseList.hasNextPage,
      isquerynostart: courseList.isquerynostart,
      indexstart: courseList.indexstart,
      nextPageNum: courseList.nextPageNum,
      curpage: courseList.curpage,
    };
  },

  // 订阅课是否点击排序
  [types.IS_SORT](state, { isSort }) {
    state.isSort = isSort;
  },

  // 订阅课列表
  [types.AJAX_GET_COLUMNLIST](state, { courseList, curpage }) {
    const columnList = state.columnList.list.concat(courseList.list);
    state.columnList = {
      list: curpage === 1 ? courseList.list : columnList,
      hasNextPage: courseList.hasNextPage,
    };
  },

  [types.MESSAGE_LIST](state, { dataList }) {
    const messageList = state.leaveMessageList.dataList.concat(dataList.dataList);
    state.leaveMessageList = {
      dataList: dataList.curpage === 1 ? dataList.dataList : messageList,
      hasNextPage: dataList.hasNextPage,
      curpage: dataList.curpage + 1,
      buyRemind: dataList.buyRemind,
      totalCount: dataList.totalCount,
    };
  },

  // 用户端 - 我的收益
  [types.AJAX_GET_MY_INCOME](state, { curpage, myIncome }) {
    let list = [];
    if (curpage === 1) {
      // 首页，清空list
      list = myIncome.list;
    } else {
      list = state.myIncome.list.concat(myIncome.list);
    }
    state.myIncome = {
      list: list,
      hasNextPage: myIncome.hasNextPage,
      sumAmount: myIncome.sumAmount,
      counts: myIncome.counts,
    };
  },
  // 专家端 所有课程列表   留言相关
  [types.AJAX_GET_COURSE_MSG_LIST](state, payload) {
    if (state.courseMsgList.curpage === 0) {
      state.courseMsgList = payload;
    } else {
      const newList = state.courseMsgList.list.concat(payload.list);
      state.courseMsgList = {
        curpage: payload.curpage,
        hasNextPage: payload.hasNextPage,
        list: newList
      }
    }
  },
  // 专家端 所有留言版列表相关
  [types.AJAX_GET_GUESTBOOK_LIST](state, payload) {
    if (payload.curpage === 1) {
      state.guestbookList = payload;
    } else {
      const newList = state.guestbookList.dataList.concat(payload.dataList);
      state.guestbookList = {
        curpage: payload.curpage,
        hasNextPage: payload.hasNextPage,
        dataList: newList
      }
    }
  },
  // 专家端 添加留言到留言列表
  [types.ADD_REPLY_TO_LIST](state, payload) {
    console.log(payload);
    // alert(`ADD_REPLY_TO_LIST${JSON.stringify(payload)}`);
    const id =  payload.id;
    if (!id) {
      return ;
    }
    const dataList = state.guestbookList.dataList;
    const i = findIndex(dataList, {id});
    dataList[i] = payload;
  },
  // 专家端 删除留言到留言列表
  [types.DEL_REPLY_TO_LIST](state, { id }) {
    const dataList = state.guestbookList.dataList;
    const i = findIndex(dataList, { replayGuestbook: { id } });
    if (i !== -1) {
      dataList[i] = Object.assign({}, dataList[i], {
        isReply: 0,
        replayGuestbook: {},
      });
      state.guestbookList = Object.assign({}, state.guestbookList, {
        dataList,
      });
    }
  },
  // 获取后台配置的静态数据
  [types.AJAX_GET_CONSTANT_DATA](state, { constantData }) {
    state.constantData = constantData;
  },
  // 会员静态数据
  [types.VIP_INFO](state, { vipInfo }) {
    state.vipInfo = vipInfo;
  },

  // 会员免费听
  [types.AJAX_GET_MEMBER_FREE_COURSE](state, { catagoryid, memberFreeCourse }) {
    let tmpList = memberFreeCourse.list;
    if (memberFreeCourse.curpage !== 1) {
      tmpList = state.memberFreeCourse.list.concat(memberFreeCourse.list);
    }
    state.memberFreeCourse = {
      catagorys: memberFreeCourse.catagorys,
      catagoryid,
      list: tmpList,
      hasNextPage: memberFreeCourse.hasNextPage,
      courseNum: memberFreeCourse.courseNum,
      curpage: memberFreeCourse.curpage,
    };
  },

  // 免费提问数
  [types.FREE_ANS_COUNT](state, freeAnsCount) {
    state.freeAnsCount = freeAnsCount;
  },
};



// WEBPACK FOOTER //
// ./src/store/mutations.js